declare global {
  interface Window {
    dataLayer?: any[];
  }
}

/* data layer parameter object must contain all required fields and only valid fields */
const requiredFields = [
  'site',
  'country',
  'globalGroup',
  'region',
  'account',
] as const;

type QualtricsField = (typeof requiredFields)[number];

export type QualtricsData = Record<QualtricsField, string | null | undefined>;

export const _setQualtricsDataLayer = (qualtricsData: QualtricsData) => {
  if (!qualtricsData || typeof qualtricsData !== 'object') {
    throw new Error('Qualtrics Data Layer input must be a valid object');
  }

  const hasAllRequiredFields = requiredFields.every(field => {
    if (qualtricsData[field] === undefined) {
      throw new Error(
        `Qualtrics Data Layer is missing required field: ${field}`,
      );
    }
    return true;
  });

  const hasOnlyValidFields = Object.keys(qualtricsData).every(key => {
    if (!requiredFields.includes(key as keyof QualtricsData)) {
      throw new Error(`Qualtrics Data Layer has invalid field: ${key}`);
    }
    return true;
  });

  if (hasAllRequiredFields && hasOnlyValidFields) {
    window.dispatchEvent(
      new CustomEvent('setQualtricsDataLayer', {
        detail: {
          event: 'qualtrics',
          ...qualtricsData,
        },
        composed: true,
      }),
    );
  }
};

export const _resetQualtricsDataLayer = () => {
  _setQualtricsDataLayer({
    site: null,
    country: null,
    globalGroup: null,
    region: null,
    account: null,
  });
};
